import get from 'lodash/get';
import { call, select } from 'redux-saga/effects';

import * as GTMConstants from '../constants';
import * as D from '../deps';

import * as GTMHelpers from './helpers';

export function* onSignUpClick({ data }) {
  yield call(GTMHelpers.pushUpgradeEvent, GTMConstants.EventNames.SIGN_UP_CLICK, data);
}

export function* onUpgradeCTAClick({ data }) {
  yield call(GTMHelpers.pushUpgradeEvent, GTMConstants.EventNames.UPGRADE_CTA_CLICK, data);
}

export function* onUpgradeDiscountPlanLinkClicked({ data }) {
  yield call(
    GTMHelpers.pushUpgradeEvent,
    GTMConstants.EventNames.UPGRADE_DISCOUNT_PLAN_LINK_CLICKED,
    data,
  );
}

export function* onViewPlansClick() {
  yield call(GTMHelpers.pushEvent, GTMConstants.EventNames.VIEW_PLANS_CLICK);
}

export function* onAppStoreCtaClick() {
  yield call(GTMHelpers.pushEvent, GTMConstants.EventNames.APP_STORE_CTA_CLICK);
}

export function* onAcquireOfferSuccess(action) {
  const didDowngrade = yield select(D.Selectors.Payments.hasUserDowngraded);
  if (didDowngrade) {
    return;
  }

  const didChangePlans = yield select(D.Selectors.Payments.didChangePlans);
  if (!didChangePlans) {
    return;
  }

  const sku = get(action, 'data.sku', '');
  const specialOfferCode = get(action, 'data.specialOfferToken', '');
  const campaignId = yield select(D.Selectors.Payments.getSpecialOfferCampaignId);

  const tier = yield select(D.Selectors.Payments.getActiveProductGroupTier);
  const discountType = yield select(D.Selectors.Payments.getActiveProductDiscountType);
  const previousTier = yield select(D.Selectors.Payments.getPreviousTier);
  const previousDiscountType = yield select(D.Selectors.Payments.getPreviousDiscountType);

  const offerPrice = yield select(D.Selectors.Payments.getActiveProductPrice);
  const isTrial = yield select(D.Selectors.Payments.getInPaymentBackedTrial);
  const durationType = yield select(D.Selectors.Payments.getActiveProductDiscountType);
  const durationTime = yield select(D.Selectors.Payments.getActiveProductDurationTime);
  const timesRenewable = yield select(D.Selectors.Payments.getActiveProductTimesRenewable);

  yield call(GTMHelpers.pushEvent, GTMConstants.EventNames.ACQUIRE_OFFER, {
    [GTMConstants.Variables.TIER]: tier,
    [GTMConstants.Variables.DISCOUNT_TYPE]: discountType,
    [GTMConstants.Variables.PREVIOUS_TIER]: previousTier,
    [GTMConstants.Variables.PREVIOUS_DISCOUNT_TYPE]: previousDiscountType,
    [GTMConstants.Variables.SKU]: sku,
    [GTMConstants.Variables.OFFER_PRICE]: offerPrice,
    [GTMConstants.Variables.SPECIAL_OFFER_CODE]: specialOfferCode,
    [GTMConstants.Variables.CAMPAIGN_ID]: campaignId,
    [GTMConstants.Variables.IS_TRIAL]: isTrial,
    [GTMConstants.Variables.DURATION_TYPE]: durationType,
    [GTMConstants.Variables.DURATION_TIME]: durationTime,
    [GTMConstants.Variables.TIMES_RENEWABLE]: timesRenewable,
    [GTMConstants.Variables.SELECTED_TIER]: null,
    [GTMConstants.Variables.SELECTED_DISCOUNT_TYPE]: null,
    [GTMConstants.Variables.SELECTED_IS_TRIAL]: null,
  });
}

export function* onListenerAndSubscriptionReady(action) {
  const authType = get(action, 'data.authType', '');
  if (authType === D.Constants.Listener.AuthTypes.RE_AUTH) {
    return;
  }

  yield call(GTMHelpers.pushEvent, GTMConstants.EventNames.AUTHENTICATION, {
    [GTMConstants.Variables.AUTH_TYPE]: authType,
  });
}
